import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { isEqual } from 'lodash';
import { push } from 'react-router-redux';
import { ExpandableContext } from '@components/contexts';
import classNames from 'classnames';
import reportActions from '@redux/reports';
import Counts from './header/counts';
import Filters from './header/filters';
import SubMenu from './header/subMenu';

class PaymentHeader extends Component {
	shouldComponentUpdate = ({
		viewType, counts, filterForm,
	}) => {
		const lastProps = this.props;
		return (
			!isEqual(lastProps.viewType, viewType)
			|| !isEqual(lastProps.counts, counts)
			|| !isEqual(lastProps.filterForm, filterForm)
		);
	};

	onViewPaymentHistory = () => {
		const { updateReportFilter, dispatch, filterForm } = this.props;
		updateReportFilter({ filterForm : { ...filterForm, reportType : 2 } }); // reporType 2 is for payment history reports
		dispatch(push({ pathname : '/reports' }));
	}

	render() {
		const {
			viewType,
			counts : { disputes },
			actionClicked,
			onExportCSV,
		} = this.props;
		const showSubMenu = viewType !== 'disputes' || viewType !== 'balance' || viewType !== 'paid';

		return (
			<div>
				<Counts />
				<Choose>
					<When condition={showSubMenu}>
						<Grid>
							<Row>
								<Col md={12}>
									<ExpandableContext.Provider>
										<SubMenu onExportCSV={onExportCSV} actionClicked={actionClicked} />
										<If condition={viewType !== 'balance' && viewType !== 'paid'}>
											<ExpandableContext.Consumer>
												{({ expanded }) => (
													<div className={classNames('search-bar payments-page expandable border-top-0', { expanded })}>
														<Filters />
													</div>
												)}
											</ExpandableContext.Consumer>
										</If>
									</ExpandableContext.Provider>
								</Col>
							</Row>
						</Grid>
					</When>
					<Otherwise>
						<Grid className="page-content padding-bottom-20">
							<Col
								md={12}
								sm={12}
							>
								<span className="text-capitalize padding-top-10 color-gray-oxford font-size-26 font-regular">
									Disputes
								</span>
							</Col>
							<Col
								md={12}
								sm={12}
							>
								<span className="padding-bottom-20 color-gray-regent font-size-16 font-regular">
									You currently have
									{ disputes }
									{' '}
									dispute(s) waiting for response from coordinator/officer
								</span>
							</Col>
						</Grid>
					</Otherwise>
				</Choose>
			</div>
		);
	}
}

const mapStateToProps = (
	{
		router : {
			match : { params : { viewType } },
		},
		payments : {
			counts,
		},
		reports : { filterForm },
	},
) => ({
	counts,
	viewType,
	filterForm,
});

const mapDispatchToProps = (dispatch) => ({
	dispatch,
	updateReportFilter : bindActionCreators(reportActions, dispatch).updateStoreProperties,
});

PaymentHeader.propTypes = {
	actionClicked      : PropTypes.func.isRequired,
	dispatch           : PropTypes.func.isRequired,
	filterForm         : PropTypes.object,
	onExportCSV        : PropTypes.func.isRequired,
	updateReportFilter : PropTypes.func.isRequired,
	viewType           : PropTypes.string,
	counts             : PropTypes.object.isRequired,
};

PaymentHeader.defaultProps = {
	filterForm : {},
	viewType   : '',
};

export default connect(mapStateToProps, mapDispatchToProps)(PaymentHeader);
